import React, { type ComponentPropsWithoutRef, forwardRef } from 'react';

import { Styled } from './styles';
import type { TextProps, TextVariant } from './types';

export { textVariants } from './types';
export type { TextProps, TextVariant } from './types';

const defaultVariant: TextVariant = 'body';

export const htmlTagByVariant: Record<TextVariant, keyof React.JSX.IntrinsicElements> = {
  body: 'span',
  'body-light': 'span',
  'body-lighter': 'span',
  caption: 'small',
};
type SpanProps = Omit<ComponentPropsWithoutRef<'span'>, keyof TextProps>;

type Props = SpanProps & TextProps;

export const Text = forwardRef<HTMLElement, Props>(
  ({ as, children, color = 'body', variant = 'body', ...props }, ref) => (
    <Styled.Span {...props} color={color} variant={variant} as={as ?? htmlTagByVariant[variant]} ref={ref}>
      {children}
    </Styled.Span>
  ),
);

Text.defaultProps = {
  variant: defaultVariant,
};

Text.displayName = 'Text';
